import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { spacingValue } from '../utils';

function size(_ref) {
  var width = _ref.width,
      height = _ref.height,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      styles = _objectWithoutPropertiesLoose(_ref, ["width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight"]);

  var props = {
    width: width,
    height: height,
    minWidth: minWidth,
    minHeight: minHeight,
    maxWidth: maxWidth,
    maxHeight: maxHeight
  };
  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (typeof value !== 'undefined') {
      styles[key] = spacingValue(value);
    }
  });
  return styles;
}

export default size;